/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { AdminDataTable } from '../../../../components';


function SupportIndustries() {

    let url = 'industry/';

    let columns = ["name"]
    let headers = ["Name", "Actions"]

    return (
        <AdminDataTable
            title="Industries"
            header={headers}
            url={url}
            column={columns}
            excelheader={['Name']}
            filename="Industries.xlsx"
            excelurl="industry-import/"
        />
    );
}

export default SupportIndustries;